$(document).ready(function () {
	if (!document.getElementById('inquirytoBuyForm')) return false;

	var iq = {
		el: document.getElementById('inquirytoBuyForm'),
		target: document.getElementById('appendTarget'),
		// 20200413 START 이지원 message 영역 count 수정
		textarea: document.getElementById('message'),
		// 20200603 START 박지영 - hk, hk_en 케이스의 분기 처리 삽입.
		countryCode : document.documentElement.attributes.getNamedItem("data-countrycode").value,
		// 20200603 END
		init: function () {
			var self = this; // LGEGMC-945
			checkTextLength($(iq.textarea), $(iq.textarea).siblings('.left-text').find('.count'));
		// 20200414 END
			$(iq.el.selectProductCategory).on({
				change: function (e) {
					// console.log();
					var _this = e.currentTarget;
					//LGEAE-438
					var _val = _this.options[_this.selectedIndex].value;
					//LGEDE-539, LGEDE-810 Start (Global 리다이렉트 제외 카테고리 추가)
					if(COUNTRY_CODE.toLowerCase() == 'de' && iq.el.selectProductCategory.value != 'CT00001738' && iq.el.selectProductCategory.value != 'CT40001381' && iq.el.selectProductCategory.value != 'CT00001736' && iq.el.selectProductCategory.value != 'CT00001362' && iq.el.selectProductCategory.value != ''){
						window.open(_this.value, '_self');
						}
					//LGEDE-539, LGEDE-810 End
					/* LGEGMC-144 20200414 add */
					iq.setAdobeValueAttr($(_this));
					/*//LGEGMC-144 20200414 add */
					
					var url = _this.options[_this.selectedIndex].getAttribute('data-url');
					//LGEAE-438 , BTOBGLOBAL-734, LGEDE-810
					if((COUNTRY_CODE.toLowerCase() == 'ae' || COUNTRY_CODE.toLowerCase() == 'ae_ar' || COUNTRY_CODE.toLowerCase() == 'hu' || COUNTRY_CODE.toLowerCase() == 'de') && _val == ''){
						$(iq.target).empty();
					} else{
					ajax.call(url, {}, 'html', function (data) {
						if (data) {
							$(iq.target).html(data);
							/* LGEGMC-945 Start */
							var itFlag=true;
							var superCategoryId = iq.el.selectProductCategory.value;
							/* LGEGMC-945 End */
							/* BTOBGLOBAL-376 : 20210216 add */
							if (!!$(iq.target).find('iframe').length) {
								/* LGEGMC-945 Start */
								$(iq.target).find('iframe').on('load', function() {
									runChosen();
									chosenScrollInit();
									$(iq.target).find('#selectCategoryOption').off('change').change(function(){
										$(iq.target).find('#destination-frame').attr('src',$(this).val());
									});
									$(iq.target).find('#selectCategoryOptionIT').off('change').change(function(){
										$(iq.target).find('#destination-frame').attr('src',$(this).val());
										var optionCategory = $(iq.target).find('#selectCategoryOptionIT option:checked').text();
										self.getEloquaData(superCategoryId, optionCategory);
										itFlag=false;
									});
								if(itFlag){
									var optionCategory = $(iq.target).find('#selectCategoryOptionIT option:checked').text();
									if(!!optionCategory){
										self.getEloquaData(superCategoryId, optionCategory);
									}else{
										self.getEloquaData(superCategoryId);
									}
								}
								});
								/*// LGEGMC-945 End */
							}else{
							/*// BTOBGLOBAL-376 : 20210216 add */

							iq.el.action = iq.el.actionUrl.value;

							var captchaBox = document.getElementById('customizedCaptcha');
							var captchaCate = $(captchaBox).find('input[name="productCategory"]');
							var myvalue = xssfilter(_this.value);
							if (captchaCate.get(0)) {
								captchaCate.val(myvalue);
							} else {
								$(captchaBox).prepend('<input type="hidden" name="productCategory" value="' + myvalue + '">');
							}
							runChosen();
							chosenScrollInit();

							if ($(iq.target).find('textarea[maxlength]').length > 0) {
								var obj = $(iq.target).find('textarea[maxlength]');
								checkTextLength(obj, obj.parent().find('.left-text .count'));
							}
							
							}

						}
					});
				 }
				}
			});
			$(iq.el).on({
				validationSuccess: function (e) {
					e.preventDefault();
					var result = captcha.validation();
					if (result != false) {
						// var noReturnFlag = result.noReturnFlag && result.noReturnFlag == "Y";
						// var url = result.url && (result.url != '' && result.url != null);
						// var param = xssfilter($(iq.el).serialize());

						// if(noReturnFlag && url) {
						// 	$.ajax({
						// 		url: url,
						// 		type: 'post',
						// 		data: param,
						// 		async: false
						// 	});
						// 	$(iq.el).find('fieldset').hide();
						// 	$(iq.el).find('.product-category').hide();
						// 	$(iq.el).find('.complete-wrap').show();

						// 	$('html, body').stop().delay(100).animate({ scrollTop: 0 }, 500);
						// }else {
						// 	e.currentTarget.submit();
						// 	// console.log('submit!');
						// }
						// 20200603 START 박지영 - hk, hk_en 케이스의 분기 처리 삽입.
						if(iq.countryCode === "hk" || iq.countryCode === "hk_en") {
							var dmCheckbox = document.getElementById('emailSubscription');
							// 20200416 START 이지원 checkbox off 값 처리
							if ($(dmCheckbox).is(":checked") == false) {
								$(dmCheckbox).parent().prepend('<input type="hidden" name="emailsubscription" id="emailSubscriptionOff" value="off">')
							}
							// 20200416 END
						}
						// 20200603 END
						e.currentTarget.submit();
					}
				},
				validationFail: function (e) {
					e.preventDefault();
				},
				submit: function (e) {
					e.preventDefault();
				},
				/* LGEGMC-144 20200414 add */
				change: function(e){
					// 20200603 START 박지영 - hk, hk_en 추가
					if (/(producttype|productSolution|products|inquiryType|inquirytype)/.test(e.target.name) && e.target.tagName === 'SELECT') {
						iq.setAdobeValueAttr($(e.target));
					}
					// 20200603 END
				}
				/* //LGEGMC-144 20200414 add */
			});

			// when loading a page, the category is already selected.
			if ($(iq.el.selectProductCategory).find('option[selected]').index() != 0) {
				$(iq.el.selectProductCategory).trigger('change');
			}
		},
		/* LGEGMC-144 20200423 add */
		setAdobeValueAttr: function($target) {
			var self = this; // LGEGMC-945
			var val = $.trim($target.val());
			// 20200603 START 박지영 - category option 문자열 대상 변경.
			var tit = val ? ($target.find('option:selected').attr('data-meta-text') ? $.trim($target.find('option:selected').attr('data-meta-text')) : $.trim($target.find('option:selected').text())) : '';
			// 20200603 END
			$target.attr('adobe-value',tit);

			if (val) {
				// 20200603 START 박지영 - hk, hk_en 추가
				var paramMap = {
					selectProductCategory:  'inquiry_to_buy_product_category_select',
					productSolution:		'inquiry_to_buy_product_solution_select',
					products:				'inquiry_to_buy_product_solution_select',
					producttype:			'inquiry_to_buy_product_solution_select', // for hk, hk_en
					inquiryType:			'inquiry_to_buy_inquiry_type_select',
					inquirytype:			'inquiry_to_buy_inquiry_type_select' // for hk, hk_en
				};
				// 20200603 END

				self.setClassificationCode(val); // LGEGMC-945
				
				var paramName = paramMap[$target[0].name];
				var param = {};
				param.page_event = {};

				param[paramName] = tit;
				
				/* LGEGMC-945 Start */
				if('inquiry_to_buy_product_category_select' == paramName){
					param.level1 = (typeof standardData === "undefined") ? '' : standardData.level1;
					param.level2 = (typeof standardData === "undefined") ? '' : standardData.level2;
				}
				/*// LGEGMC-945 End */
				param.page_event[paramName] = true;
				adobeTrackEvent(paramName, param);
			}
		},
		/*//LGEGMC-144 20200423 add */
		/* LGEGMC-945 Start */
		setClassificationCode: function(categoryId){
			var self = this;
			if(typeof standardData != 'undefined'){
				var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/retrieveCategoryBuInfo?bizType=B2B&categoryId='+categoryId;
				$.ajax({
					type:"post",
					url: url,
					dataType: "json",
					async: false,
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						standardData.level1 = data.data[0].buName.buName1;
						standardData.level2 = data.data[0].buName.buName2;
						standardData.level3 = data.data[0].buName.buName3;
					},
					error: function(request,status,error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			}
		},
		getEloquaData: function(superCategoryId,optionCategory){
			if(!document.getElementsByClassName('gpEloquaForm')[0]){
				return;
			}
			var iframe = document.getElementsByClassName('gpEloquaForm')[0].contentWindow;
			
			var self = this;
			var object = {};
			object['superCategoryId'] = superCategoryId;
			if(optionCategory){
				object['categoryName'] = $.trim(optionCategory);
			}
			if(!!superCategoryId){
				var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/inquirytobuy/getEloquaData';
				$.ajax({
					type:"post",
					url: url,
					data: object,
					dataType: 'json',
					async: false,
					xhrFields: {
						withCredentials: true
					},
					success: function(data) {
						if(data.result){
							console.log('Eloqua data search success');
							setTimeout(function() {
								iframe.postMessage(data,'*');
							}, 2000);
						}else{
							console.log('no Eloqua data');
						}
					},
					error: function(request,status,error) {
						console.log("status: "+status);
						console.log("error: "+error);
					}
				});
			}
		}
		/*// LGEGMC-945 End */
	};

	iq.init();

	$('#appendTarget').on('input mouseup mouseenter', 'input, textarea', function () {
		var val = $(this).val();
		$(this).val(xssfilter(val, 'form'));
	});
});
